var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusseat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 18
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "busseat_svg__a",
    d: "M.073 2.436C.073 1.113 1.028.04 2.206.04h9.383c1.178 0 2.133 1.072 2.133 2.395v9.913c0 1.322-.954 2.394-2.133 2.394H2.206c-1.178 0-2.133-1.072-2.133-2.394V2.436z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-90 8.042 7.542)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "busseat_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#busseat_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#8F908C",
    strokeWidth: 0.75,
    d: "M.073 2.436C.073 1.113 1.028.04 2.206.04h9.383c1.178 0 2.133 1.072 2.133 2.395v9.913c0 1.322-.954 2.394-2.133 2.394H2.206c-1.178 0-2.133-1.072-2.133-2.394V2.436h0z",
    mask: "url(#busseat_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C7C7C2",
    d: "M15.05 4.05H8.613c-.339 0-.614-.253-.614-.565V1.648c0-.312.275-.565.614-.565h8.772c.339 0 .614.253.614.565v14.674-.007.203c0 .312-.275.565-.614.565H8.614c-.339 0-.614-.253-.614-.565v-1.837c0-.312.275-.565.614-.565h6.435V4.05z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7C7E7A",
    strokeWidth: 0.75,
    d: "M15.05 4.05H8.613c-.339 0-.614-.253-.614-.565V1.648c0-.312.275-.565.614-.565h8.772c.339 0 .614.253.614.565v14.674-.007.203c0 .312-.275.565-.614.565H8.614c-.339 0-.614-.253-.614-.565v-1.837c0-.312.275-.565.614-.565h6.435V4.05z"
  }))));
}
export default SvgBusseat;